import React from 'react'

const Interests = (props) => (
    <section className="interests">
        <div className="inner">
            <header className="">
                <h1 className="pf display-4"><strong>Interesses</strong></h1>
            </header>
            <h2>
                <ul>
                    <li> <i className="fa fa-square pr-1"></i> Moda</li>
                    <li> <i className="fa fa-square pr-1"></i> Beleza</li>
                    <li> <i className="fa fa-square pr-1"></i> Cultura Pop</li>
                    <li> <i className="fa fa-square pr-1"></i> Política</li>
                    <li> <i className="fa fa-square pr-1"></i> Literatura</li>
                    <li> <i className="fa fa-square pr-1"></i> Arte</li>
                </ul>
            </h2>
        </div>
    </section>
)

export default Interests
